import { mac } from './platform.js';

/** Return true if any modifier key (alt, meta, shift, ctrl) is pressed. */
function isAnyModifierPressed(e) {
    return e.altKey || e.metaKey || e.shiftKey || e.ctrlKey;
}
function isStandardShortcutKeyPressed(e) {
    return mac ? e.metaKey : e.ctrlKey;
}
function getModifiers(e) {
    let modifiers = 0;
    if (e.altKey)
        modifiers |= 1 /* Modifier.ALT */;
    if (e.metaKey)
        modifiers |= 2 /* Modifier.META */;
    if (e.shiftKey)
        modifiers |= 4 /* Modifier.SHIFT */;
    if (e.ctrlKey)
        modifiers |= 8 /* Modifier.CONTROL */;
    return modifiers;
}

export { getModifiers, isAnyModifierPressed, isStandardShortcutKeyPressed };
//# sourceMappingURL=modifiers.js.map
